<template>
  <div class="layout">
    <Layout>
      <AppHeader :selectMenu="selectMenu" />
      <Layout>
        <Sider hide-trigger width="100" :style="{ background: '#fff' }" v-if="canShowSidBar()" class="sidebar-part">
          <Menu :active-name="siderMenu" theme="light" width="auto">
            <MenuItem name="11-1" :to="{ name: 'running', query: { mac: this.$route.query.mac } }"
              v-show="canShow('running.view')" class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/left-menu-11-1.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("k001") }}</div>
            </MenuItem>
            <MenuItem name="12-1" :to="{ name: 'program', query: { mac: this.$route.query.mac } }"
              v-show="canShow('program.view')" class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/left-menu-12-1.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("k002") }}</div>
            </MenuItem>
            <MenuItem name="13-1" :to="{ name: 'production', query: { mac: this.$route.query.mac } }"
              v-show="canShow('production.view')" class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/left-menu-13-1.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("k003") }}</div>
            </MenuItem>
            <MenuItem name="14-1" :to="{ name: 'system', query: { mac: this.$route.query.mac } }"
              v-show="canShow('system.view')" class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/left-menu-14-1.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("k004") }}</div>
            </MenuItem>
            <MenuItem name="15-1" :to="{ name: 'record', query: { mac: this.$route.query.mac } }"
              v-show="canShow('record.view')" class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/left-menu-15-1.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("k005") }}</div>
            </MenuItem>
            <MenuItem name="16-1" :to="{ name: 'alarm', query: { mac: this.$route.query.mac } }"
              v-show="canShow('alarm.view')" class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/left-menu-16-1.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("k006") }}</div>
            </MenuItem>
            <MenuItem name="17-1" :to="{ name: 'modification', query: { mac: this.$route.query.mac } }"
              v-show="canShow('modification.view')" class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/left-menu-17-1.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("k007") }}</div>
            </MenuItem>
            <MenuItem name="18-1" :to="{ name: 'prodspot', query: { mac: this.$route.query.mac } }"
            v-show="canShow('prodspot.view') && canshow803"
              class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/left-menu-18-1.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("k008") }}</div>
            </MenuItem>
             <MenuItem name="19-1" :to="{ name: 'fix', query: { mac: this.$route.query.mac } }"
              v-show="canShow('fix.view')" class="menu-item-vertical">
            <div class="menu-icon-wrapper">
              <img :src="require('@/assets/img/left-menu-19-1.png')" class="menu-icon" />
            </div>
            <div class="menu-text">{{ getTranslation("p047") }}</div>
            </MenuItem>
          </Menu>
        </Sider>

        <Layout :style="{ padding: '0 10px 10px' }">
          <AppBreadcrumb :sideBar="sideBar"></AppBreadcrumb>
          <Content :style="{ padding: '10px', minHeight: '280px', background: '#fff' }">
            <slot></slot>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import AppHeader from './AppHeader'
import { mapGetters } from 'vuex'
import AppBreadcrumb from './AppBreadcrumb'
import { Layout, Content, Menu, MenuItem, Sider } from 'view-design'
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { postJsError,KindOf803 } from '@/util/util.js'
export default {
  name: 'MainLayout',
  computed: {
    ...mapGetters(['getTranslation']),
    canshow803(){
      let rs = false;      
      if(this.machineInfo && KindOf803(this.machineInfo.kind)){
        rs = true;
      }      
      return rs;
    }
  },
  components: {
    Layout, Content,
    AppHeader,
    AppBreadcrumb, Menu, MenuItem, Sider
  },
  props: {
    selectMenu: {
      type: String,
      default: '1-1'
    },
    sideBar: {
      type: String,
      default: ''
    },
    siderMenu: {
      type: String,
      default: '11-1'
    }
  },
  created() {
    this.getUserInfo();
    this.getMachineInfo();
    
  },
  data() {
    return {
      userInfo: {},
      machineInfo:null,
    }
  },
  methods: {
    async getUserInfo() {
      let _this = this;
      let url = API_URL["userGetInfo"];
      let res = await axios.get(url)
        .catch((err) => {
          postJsError(err)
        })
      if (res && res.data && res.data.code == 200) {
        this.$nextTick(() => {
          _this.userInfo = res.data.data;
        });
        
      }
    },
    async getMachineInfo() {
      let _this = this;
      if (!this.$route.query.mac) {
        return;
      }
      let url = API_URL["machineGetInfo"] + "?mac=" + this.$route.query.mac;      
      let res = await axios.get(url)
        .catch((err) => {
          postJsError(err)
        })
      if (res && res.data && res.data.code == 200) {       
          _this.machineInfo = res.data.data;
      }
    },
    canShow(key) {
      if (!this.userInfo.auth) {
        return false;
      }
      let auth = this.userInfo.auth;
      if (auth === 'all') {
        return true;
      } else {
        return auth.includes(key);
      }
    },
    canShowSidBar() {
      return  this.sideBar != null && this.sideBar != undefined && this.sideBar != '';     
    }
  }
}
</script>

<style scoped>

.sidebar-part>>>.ivu-layout-sider {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

.sidebar-part>>>.ivu-menu {
  width: 100px;
}

.sidebar-part>>>.ivu-menu-item {
  padding: 12px 8px;
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  transition: all 0.2s ease;
}

.sidebar-part>>>.ivu-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

/* 选中状态样式 - 更深的高亮 */
.sidebar-part>>>.ivu-menu-item-active,
.sidebar-part>>>.ivu-menu-item-selected {
  background-color: #d0e8ff !important;
  color: #1c6fcf !important;
  border-left: 5px solid #1c6fcf;
}

.sidebar-part>>>.ivu-menu-item-active .menu-text,
.sidebar-part>>>.ivu-menu-item-selected .menu-text {
  color: #1c6fcf;
  font-weight: 600;
}

.sidebar-part>>>.ivu-menu-item:last-child {
  border-bottom: none;
}

.sidebar-part>>>.ivu-icon {
  font-size: 16px;
  margin-right: 0;
}

/* 垂直菜单项样式 */
.sidebar-part>>>.menu-item-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70px;
  padding: 6px 2px;
}

.sidebar-part>>>.menu-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  margin-bottom: 2px;
}

.sidebar-part>>>.menu-icon {
  font-size: 20px !important;
  width: 32px;
  text-align: center;
}

.sidebar-part>>>.menu-text {
  font-size: 11px;
  line-height: 1.1;
  text-align: center;
  word-break: break-all;
  max-width: 100%;
  padding: 0 1px;
}
</style>